import utils from '../../utils';
import fetch from '../fetch';


const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const getSelection = () => {
    return DataGrid.selections;
}

const columns = utils.columns([
    {
        key: '$index',
        label: '序号'
    },
    {
        key: 'orgName',
        label: '所属部门'
    },
    {
        key: 'employeeCode',
        label: '教师工号'
    },
    {
        key: 'employeeName',
        label: '教师姓名'
    },
    {
        key: 'courseOrgName',
        label: '开课部门'
    },
    {
        key: 'courseNo',
        label: '课程代码'
    },
    {
        key: 'courseName',
        label: '课程名称'
    },
    {
        key: 'evalNumber',
        label: '参评人数'
    },
    {
        key: 'evalScore',
        label: '评价分'
    },
    {
        key: 'termName',
        label: '所属学期'
    },
])


const prefixUrl = 'teacher/teaching/quality/student/eval/courseScore';


const querySearch = ( keywords ) => {
    return fetch.post(`${prefixUrl}/query?pageNum=${keywords.pageNum}&pageSize=${keywords.pageSize}&sort=${keywords.sort || ''}&order=${keywords.order || ''}`,keywords)
    .then(res => {
        let data = res.payload.data;
        return Object.assign({
            result: data.dataList,
            selects: data.dataList.map(e => {
                return{
                    value: e.id,
                    checked: false, 
                }
            }),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data.dataList || []).length ? '' : '暂无数据...'
        })
    })
    
}

const remove = (ids) => {
    return fetch.post(`${prefixUrl}/delete`,ids)
    .then(res => {
        if(res.code === 200)    {
            return res.payload.data;
        }
    })
}

const queryById = (id) => {
    return fetch.post(`${prefixUrl}/get/${id}`)
    .then(res => {
        if(res.code === 200) {
            return res.payload.data;
        }
    })
}

const update = (data) => {
    return fetch.post(`${prefixUrl}/update`,data)
    .then(res => {
        if(res.code === 200) {
            DataGrid.refresh();
            DataGrid.selections= [];
            return res;
        }
    })
}

const querySearchByCourseName = (keywords) => {
    return fetch.get(`course/query/by/courseName?courseName=${keywords.courseName || ''}&limit=${keywords.limit || undefined}`)
    .then(res => {
        if ( res.code === 200 ) {
            return res.payload.data
        }
    })
}

const queryByEmployeeName = (params) => {
    return fetch.get(`employee/query/by/employeeName?employeeName=${params.employeeName || ''}&limit=${params.limit || undefined}`)
    .then(res => {
        if ( res.code === 200 ) {
            return res.payload.data;
        }
    })
}

export default {
    queryByEmployeeName,
    querySearchByCourseName,
    update,
    queryById,
    remove,
    onSelect,
    setRefresh,
    getSelection,
    querySearch,
    columns
}